import { breakpoints } from "../../constants/breakpoints/breakpoints.js";
import { createTheme } from "../../constants/create-theme/create-theme.js";
import { MuiAlert } from "../alert/alert.js";
import { MuiButton } from "../button/button.js";
import { MuiCheckbox } from "../checkbox/checkbox.js";
import { MuiFormControlLabel } from "../form-control-label/form-control-label.js";
import { MuiRadio } from "../radio/radio.js";
import { MuiSwitch } from "../switch/switch.js";
import { typography } from "../typography/typography.js";
import "@mui/material/styles";
import "../../constants/colors/palette.js";
import "../shadows/shadows.js";
import "@mui/material";
import "../typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../typography/utils/typographyVariants/typographyVariants.js";
import "react/jsx-runtime";
import "../alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../alert/components/InfoIcon/InfoIcon.js";
import "../alert/components/SuccessIcon/SuccessIcon.js";
import "../alert/components/WarningIcon/WarningIcon.js";
import "../button/styles/external/bordered.styles.js";
import "color-alpha";
import "../button/styles/external/filled.styles.js";
import "../button/styles/internal/bordered.styles.js";
import "../button/styles/internal/borderless.styles.js";
import "../button/styles/internal/filled.styles.js";
import "../button/styles/internal/shadowed.styles.js";
import "../checkbox/components/CheckedIcon/CheckedIcon.js";
import "../checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
let theme = createTheme({
  variant: "external",
  typography,
  breakpoints
});
theme = createTheme({
  ...theme,
  components: {
    MuiButton,
    MuiAlert,
    MuiFormControlLabel,
    MuiCheckbox,
    MuiRadio,
    MuiSwitch,
    MuiContainer: {
      styleOverrides: {
        root: {
          [theme.breakpoints.down("md")]: {
            paddingLeft: "24px",
            paddingRight: "24px"
          },
          [theme.breakpoints.up("md")]: {
            paddingLeft: "36px",
            paddingRight: "36px"
          }
        }
      }
    },
    MuiStepIcon: {
      styleOverrides: {
        text: {
          fontFamily: "Lato",
          fontSize: 17
        }
      }
    }
  }
});
const ExternalTheme = theme;
export {
  ExternalTheme
};
